// Helpers
import api from "./api";

export const createGame = async ({ data, successCb, errorCb }) => {
    await api
        .post({ path: "website/games", data })
        .then(response => {
            const data = response.data;

            successCb && successCb(data);
        })
        .catch(err => {
            console.error("Error creating game:", err);
            errorCb && errorCb();
        });
};
